<table>
    @for (d of data; track d._key) {
        <tr>
            <td><div [style]="'background-color:' + d.color" class="colour-bar"></div></td>
            <td>{{d.name}}</td>
            <td style="text-align: right;padding-left: 10px;">
                @if (isCurrency) {
                    {{d.value | currency: currencyCode: 'symbol-narrow': '1.0-0'}}
                }@else {
                    {{d.value | number}}
                }
            </td>
            <td style="text-align: right;padding-left: 10px;">{{getPercentage(d)}}</td>
        </tr>
    }
</table>
